/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

import Auth from '@/layouts/Auth.vue'
import Dashboard from '@/layouts/Dashboard.vue'
import Nucleas from '@/layouts/Nucleas.vue'

import DashboardOverview from '@/layouts/dashboard/Overview.vue'

import ProfileOverview from '@/layouts/profile/Overview.vue'

import SettingsOverview from '@/layouts/settings/Overview.vue'

import Finance from '@/layouts/Finance.vue'
import FinancePayout from '@/layouts/finance/Payout.vue'
import FinancePayroll from '@/layouts/finance/Payroll.vue'
import FinanceStats from '@/layouts/finance/Stats.vue'
import FinanceMy from '@/layouts/finance/My.vue'

import Base from '@/layouts/Base.vue'
import Knowledge from '@/layouts/base-knowledge/Links.vue'
import BaseSettings from '@/layouts/base-knowledge/Settings.vue'

import UsersList from '@/layouts/users/List.vue'

import _blank from '@/layouts/_blank.vue'

import { isAuthenticated } from '@/plugins/_helpers'

Vue.use(Router);

const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/",
            component: Auth,
	        name:'auth'
        },
	    {
		    path: "/reset",
		    component: Auth,
            name:'reset',
		    
			},
			{
		    path: "/nucleas",
		    component: Nucleas,
            name:'nucleas',
		    
	    },
	    {
		    path: "/restore",
		    component: Auth,
		    name:'restore'
	    },
	    {
		    path: "/complete",
		    component: Auth,
		    name:'auth_complete'
	    },
	    {
		    path: "/dashboard",
		    component: Dashboard,
		    beforeEnter:isAuthenticated,
		    children:[
			    {
			    	path:'overview',
				    component:DashboardOverview,
				    name:'dashboard'
			    },
			    {
				    path:'feed',
				    component:DashboardOverview,
				    name:'feed'
			    },
			    {
				    path:'karma',
				    component:DashboardOverview,
				    name:'karma'
			    },
			    {
				    path:'profile',
				    component:ProfileOverview,
				    children:[
					    {
						    path:'overview',
						    name:'profile_overview',
						    component: _blank
					    }
				    ]
			    },
			   
			    {
				    path:'finance',
				    component:Finance,
				    children:[
					    {
						    path:'payout',
						    name:'finance_payout',
						    component: FinancePayout
					    },
					    {
						    path:'payroll',
						    name:'finance_payroll',
						    component: FinancePayroll
					    },
					    {
						    path:'my',
						    name:'finance_my',
						    component: FinanceMy
					    },
					    {
						    path:'stats',
						    name:'finance_stats',
						    component: FinanceStats
					    }
				    ]
			    },
			    
			    {
			    	path:'base_knowledge',
						component: Base,
						children:[
					    {
						    path:'settings',
						    name:'base_settings',
						    component: BaseSettings
							},
							{
								path:'links',
								name:'base_knowledge',
								component: Knowledge,
							}
				    ]
					},
					{
			    	path:'users',
				    name:'users_list',
				    component:UsersList,
			    },
			    {
				    path:'settings',
				    component:SettingsOverview,
				    children:[
					    {
						    path:'overview',
						    name:'settings_overview',
						    component: _blank
					    }
				    ]
			    }
		    ]
	    }
    ]
});
router.afterEach( to => {
	
	if( router.app.$mediaQuery() === 'mobile') router.app.$store.dispatch('app/setSettings',{ full: true })
	setTimeout(() => router.app.$store.commit('app/setLoading', false), 300 )
})

export default router;

/*
 {
				    path:'game',
				    component:_blank,
				    children:[
					    {
						    path:'rate',
						    name:'rate',
						    component: _blank
					    },
					    {
						    path:'score',
						    name:'score',
						    component: _blank
					    },
					    {
						    path:'stats',
						    name:'stats',
						    component: _blank
					    }
				    ]
			    },
{
				    path:'projects',
				    component:_blank,
				    children:[
					    {
						    path:'overview',
						    name:'projects_overview',
						    component: _blank
					    }
				    ]
			    },
			    {
				    path:'knowledge',
				    component:_blank,
				    children:[
					    {
						    path:'overview',
						    name:'knowledge_overview',
						    component: _blank
					    }
				    ]
			    },
 */